import { useCallback, useState } from 'react';

import type { SeatKind } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

import type { SeatHolder } from './memberSeats';

export type SeatActionKind =
  | 'assignCoaches'
  | 'move'
  | 'revoke'
  | 'addCohort'
  | 'removeCohort'
  | 'addToCoachRoster';

export type SeatAction = Readonly<{
  kind: SeatActionKind;
  holders: readonly SeatHolder[];
  /** The kind of the tab the door was opened from. */
  seatKind: SeatKind;
}>;

export const useSeatActions = () => {
  const [action, setAction] = useState<SeatAction | null>(null);

  const open = useCallback(
    (kind: SeatActionKind, holders: readonly SeatHolder[], seatKind: SeatKind) => {
      setAction({ kind, holders, seatKind });
    },
    [],
  );

  const close = useCallback(() => setAction(null), []);

  return { action, open, close };
};
